<!--<aup-activity-title>Quick Contact Form</aup-activity-title>-->
<aup-activity-body>
  <spa-common-contact-form [cancelCommand]="cancelCommand" [formContext]="formContext" [message]="activityData?.initialBodyText"></spa-common-contact-form>
</aup-activity-body>
